import React from "react";
import PropTypes from "prop-types";
import DynamicNavItem from "./DynamicNavItem";
import { List, Typography, Box } from "@mui/material";

const DynamicNavGroup = ({item, level}) => {
    // console.log(item,"ITEm")

    const navItems = item.children.map((dynamicItem) => (
        <DynamicNavItem key={dynamicItem.id} item={dynamicItem} level={1} />
      ));

  return (
    <List
    subheader={
      item.title && (
        <Box sx={{ pl: 3, mb: 1.5 }}>
          <Typography variant="subtitle2" color="textSecondary">
            {item.title}
          </Typography>
        </Box>
      )
    }
    sx={{ mb: 1.5, py: 0, zIndex: 0 }}
  >
    {navItems}
  </List>
  )
}

export default DynamicNavGroup